import { Card, Grid, Tab, Tabs,CardActionArea, CardMedia, CardContent, Typography, Grow,Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import React, { useState } from 'react';
import resumeData from '../../Utils/resumeData';
import './Portfolio.css'
const Portfolio = () => {
const [projectDialog, setprojectDialog] = useState(false)
    const [Tabvalue, setTabvalue] = useState("ALL")
// const portfolioDialog = () => (

// )
    return (
        <div>
          <Grid className=" section">
                <Grid item className="sectionTitle mb_20" >
                    <span></span>
                    <h6  className="sectiontitle_text" >Portfolio</h6>
                </Grid>
{/*<<<<<<<<<<<<<<<<<<<<<<<<<<<<< Tabs */}
                <Grid item xs={12} >
                    <Tabs value={Tabvalue} indicatorColor="white" className="custom_tag" onChange={(event,newValue) => setTabvalue(newValue)} >
                    
                    <Tab variant="outlined" label="ALL" value="ALL" className={ Tabvalue == 'ALL' ? 'custom_item_active' : 'customtabs_item '} 
                        
                        />
                    {
                       [...new Set(resumeData.portfolio.map(item => item.tag))].map(tag => (
                           <Tab 
                           label={tag}
                           value={tag}
                           className={ Tabvalue == tag ? 'custom_item_active' : 'customtabs_item'}
                           />
                       ))
                    }
                       

                    </Tabs>
                </Grid>
                <Grid item xs={12}>

{/*<<<<<<<<<<<<<<<<<<<<<<<<<<<<< Projects */}

<Grid item xs={12}>
    <Grid container className="project">
        {
            resumeData.portfolio.map(portfolios => (
                <>
                { Tabvalue  == portfolios.tag || Tabvalue === 'ALL' ? (
                        <Grid item xs={12} sm={6} md={6}  >
                        <Grow in timeout={4000}>
                                <Card
                                onClick={()=>setprojectDialog(portfolios)}
                                className={'customCard '} >
                                        <CardActionArea >
                                            <CardMedia />
                                            <CardContent className="margin_all">                                                              
                                                <CardMedia image={portfolios.image} title={portfolios.title} className="customCard_img" />
                                                <Typography variant="body2" className="customCard_title">{portfolios.title}</Typography>
                                                <Typography variant="body2" className="customCard_txt" >{portfolios.Captaion}</Typography>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                        </Grow>
                    </Grid>
                ) :null }
                
                </>
                
            ))
        }
    </Grid>
</Grid>
                </Grid>

    <Dialog fullWidth={true} className="projectDialog " open={projectDialog} onClose={()=>setprojectDialog(false)}>
        <DialogTitle  onClose={()=>setprojectDialog(false)}>
          
                 {projectDialog.title}
           
           
        </DialogTitle>
        <img src={projectDialog.image} alt="" className="projectDialog_img" />
        <DialogContent dividers className="projectDialog_description">
        {projectDialog.description}
        </DialogContent>
        <DialogActions className="projectDialog_action">
            {
                projectDialog?.url?.map(link => (
                    <a href={link.link} target="_blank" className="projectDialog_icon" >{link.icon}</a>
                ))
            }
        </DialogActions>
    </Dialog>
          </Grid>
        </div>
    );
};

export default Portfolio;
